const turnstileScript = {
  src: "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit",
};

export const deprecated_createTurnstile = (selector: string) => {
  createTurnstileScript(() => {
    const container =
      document.querySelector<HTMLElement>(selector) ?? undefined;

    if (container !== undefined) {
      const input = container.querySelector("input") ?? undefined;

      if (input !== undefined) {
        turnstile.reset(container);
      } else {
        turnstile.render(container);
      }
    }
  });
};

export const getTurnstile = async () => {
  return new Promise<Turnstile.Turnstile>((resolve) => {
    createTurnstileScript(() => {
      resolve(turnstile);
    });
  });
};

const createTurnstileScript = (callback: () => void) => {
  const script =
    document.querySelector<HTMLScriptElement>(
      `[src="${turnstileScript.src}"]`,
    ) ?? document.createElement("script");

  if (script.src.length === 0) {
    script.src = turnstileScript.src;
    script.defer = true;
  }

  if (typeof turnstile === "undefined") {
    script.addEventListener("load", () => callback(), {
      once: true,
    });
  } else {
    callback();
  }

  if (script.parentElement === null) {
    document.body.appendChild(script);
  }
};

export const getTurnstileToken = async (siteKey: string): Promise<string> => {
  return new Promise((resolve) => {
    createTurnstileScript(async () => {
      try {
        const token = await getToken(siteKey);

        resolve(token);
      } catch {
        resolve("");
      }
    });
  });
};

const getToken = (siteKey: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const container = document.createElement("div");

    document.body.appendChild(container);

    turnstile.render(container, {
      sitekey: siteKey,
      size: "flexible",

      callback: (token) => {
        document.body.removeChild(container);
        resolve(token);
      },

      "error-callback": (error) => {
        document.body.removeChild(container);
        reject(error);
      },
    });
  });
};
